/**
 * @format
 */
import { api } from '@/scripts/api';

export const ProofOfPaymentService = {
    getByInvoiceId({ invoiceId, accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/payment-proofs/account/${accountId}/invoice/${invoiceId}`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    upload({ payload, accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/payment-proofs/vendor-account/${accountId}`;

            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    delete({ accountId, invoiceId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/payment-proofs/vendor-account/${accountId}/invoice/${invoiceId}`;

            api.delete(service).then(resolve).catch(reject);
        });
    },
};
